import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { useBookmarks } from '../../context/BookmarksContext';
import useBodyScrollLock from '../../utils/useBodyScrollLock';
import './CreateBookmarkFolderModal.css';

const CreateBookmarkFolderModal = ({ onClose }) => {
  const { createFolder } = useBookmarks();
  const [folderName, setfolderName] = useState('');
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState('');

  useBodyScrollLock(true);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = folderName.trim();
    
    if (!name) {
      setError('Folder name cannot be empty');
      return;
    }
    if (name.length > 50) {
      setError('Folder name must be under 50 characters');
      return;
    }

    setCreating(true);
    setError('');

    try {
      await createFolder(name);
      onClose();
    } catch (err) {
      console.error('Error creating folder:', err);
      setError(err.response?.data?.error || err.message || 'Failed to create folder');
    } finally {
      setCreating(false);
    }
  };

  const handleBackdropClick = (e) => {
    if (e.target.className === 'modal-backdrop') {
      onClose();
    }
  };

  const modalContent = (
    <div className="modal-backdrop" onClick={handleBackdropClick}>
      <div className="create-folder-modal">
        <div className="modal-header">
          <h2>Create Bookmark Folder</h2>
          <button className="close-btn" onClick={onClose} aria-label="Close modal">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="folder-form">
          <div className="form-group">
            <label htmlFor="folderName" className="form-label">Name</label>
            <input
              id="folderName"
              type="text"
              className="folder-input"
              value={folderName}
              onChange={(e) => setfolderName(e.target.value)}
              placeholder="e.g., Favorite Authors, Crypto News..."
              autoFocus
              maxLength={50}
              disabled={creating}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="folder-actions">
            <button
              type="button"
              className="folder-cancel-btn"
              onClick={onClose}
              disabled={creating}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="folder-submit-btn"
              disabled={creating || !folderName.trim()}
            >
              {creating ? 'Creating...' : 'Create folder'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  if (typeof document === 'undefined') {
    return modalContent;
  }

  return createPortal(modalContent, document.body);
};

export default CreateBookmarkFolderModal;

